module.exports = __webpack_public_path__ + "img/product-iron-on.f5f85753.png";